import { buildAxiosWithoutInterceptors, buildMakeUseAxios } from "@root/api/api.tools";

export const authAxios = buildMakeUseAxios(`${import.meta.env.VITE_AUTH_URL}/auth`);
export const authAxiosWithoutInterceptors = buildAxiosWithoutInterceptors(`${import.meta.env.VITE_AUTH_URL}/auth`);
